import { render } from "./ShipToSelector.vue?vue&type=template&id=dc3b8716"
import script from "./ShipToSelector.vue?vue&type=script&lang=js"
export * from "./ShipToSelector.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__